import React, {useEffect, useState} from "react";
import {CirastServico} from "../../servicos";
import {exibirMensagemErro, formatarData} from "../../util";
import {useParams} from "react-router-dom";
import logoLogin from "../../img/png/logo_login.png";

export default function ImpressaoCirast() {

  const params = useParams()
  const [dados, setDados] = useState({})
  const [consultaCirast, setConsulta] = useState({})

  useEffect(() => {
    CirastServico.imprimir(params.id)
      .then(res => res.json())
      .then(dados => {
        setDados(dados)
        setConsulta(dados.consultaCirast)
      })
      .catch(() => exibirMensagemErro("Ocorreu um erro ao baixar pdf"))
      .finally(() => {
      })
  }, [])

  return (
    <div className="row">
      <div className="col-lg-12 text-center mt-1">
        <div className="card col-lg-12">
          <div className="card-header text-center">
            <img src={logoLogin} alt={"logo asplan"}/>
          </div>
          <div className="card-body col-lg-12">
            <h2> Marcação de consulta </h2>

            <div className="row mt-3 fieldset">
              <div className="col-lg">
                <h4>Paciente: <b>{dados.paciente}</b></h4>
              </div>
              <div className="col-lg">
                <h4>CPF paciente: <b>{dados.consultaCirast?.cpfPaciente}</b></h4>
              </div>
              <div className="col-lg">
                <h4>Atendimento: <b>{dados.consultaCirast?.tpAntedimento}</b></h4>
              </div>
              <div className="col-lg">
                <h4>Prontuário: <b>{dados.consultaCirast?.prontuario}</b></h4>
              </div>
              <div className="col-lg">
                <h4>Cadastrante: <b>{dados.cadastrante}</b></h4>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg-2">
                <h4>Clinica: <b>{dados.consultaCirast?.clinicaCirast.nome}</b></h4>
              </div>
              <div className="col-lg-4">
                <h4>
                  Endereco: <b>{dados.consultaCirast?.clinicaCirast.logradouro}, </b>
                  nº: {dados.consultaCirast?.clinicaCirast.numero}
                </h4>
              </div>
              <div className="col-lg-1">
                <h4>CEP: <b>{dados.consultaCirast?.clinicaCirast.cep}</b></h4>
              </div>
              <div className="col-lg-4">
                <h4>CNPJ: <b>{dados.consultaCirast?.clinicaCirast.cnpj}</b></h4>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <h4>Início da validade: <b>{formatarData(dados.data)}</b></h4>
              </div>
              <div className="col-lg">
                <h4>Qtd de atendimentos: <b>{dados.consultaCirast?.qtdSolicitado}</b></h4>
              </div>
              <div className="col-lg">
                <h4>Fim da validade: <b>{formatarData(consultaCirast?.dataValidade)}</b></h4>
              </div>
            </div>

            <div>
              <img src={`data:image/png;base64,${dados.qrCode}`} height={200} width={200}/> <br/>
              <small>Caso não consiga acessar o qrcode, acesse:</small> <br/>
              <p><b>https://asplan.ssp.se.gov.br/publica/atendimento-cirast/{params.id}</b></p> <br/>
              <small>Entregue esse qrcode na recepção da clínica para validar o atendimento</small>
            </div>
          </div>
        </div>
        <hr/>
        <div className="col-lg-12">
          <div className="">
            <h3>Assinaturas</h3>
          </div>

          <div className="row mt-2">
            <div className="col-lg-6">
              __________________________________ <br/>
              {dados.paciente}
            </div>
            <div className="col-lg-6">
              __________________________________ <br/>
              Profissional
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg">
              __________________________________ <br/>
              {dados.paciente}
            </div>
            <div className="col-lg">
              __________________________________ <br/>
              Profissional
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg">
              __________________________________ <br/>
              {dados.paciente}
            </div>
            <div className="col-lg">
              __________________________________ <br/>
              Profissional
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg">
              __________________________________ <br/>
              {dados.paciente}
            </div>
            <div className="col-lg">
              __________________________________ <br/>
              Profissional
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg">
              __________________________________ <br/>
              {dados.paciente}
            </div>
            <div className="col-lg">
              __________________________________ <br/>
              Profissional
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}